// DiseaseSpecializationFilter.jsx
import React from 'react';
import { filters_tmpl, filter_tmpl_specialist } from './data';
import './DiseaseSpecializationFilter.css';

const DiseaseSpecializationFilter = ({ 
  filters, 
  setFilters, 
  layout = 'single', // 'single' или 'double'
  showTitle = true,
  className = '',
  typeFilter = 'standart'
}) => {


  const _filters_tmpl = typeFilter == 'standart' ? filters_tmpl : filter_tmpl_specialist;
  

  const setGroupsFilter = (field, part) => {
    const outFilter = { ...filters };
    const gr_obj = { ...filters[part] };
    
    if(part == 'specialization') {
      outFilter['disease_type'] = {};

      Object.keys(gr_obj).forEach(k=>{
        gr_obj[k] = k == field ? !gr_obj[k] : false; 
      });
      
    } else {
      gr_obj[field] = !gr_obj[field];
    }
    
    outFilter[part] = gr_obj;
    setFilters(outFilter);
  };

  // Визначаємо, які типи захворювань показувати
  const [showDiseaseFilters, showSanatoriumDiseases, showSpecialDiseases] = typeFilter == 'standart' ? [
    filters.specialization.combined || filters.specialization.sanatorium || filters.specialization.special,
    filters.specialization.sanatorium || filters.specialization.combined,
    filters.specialization.special || filters.specialization.combined
  ] :
  [
    filters.specialization.combined || filters.specialization.sanatorium,
    filters.specialization.sanatorium,
    filters.specialization.combined
  ];

  console.log({ _filters_tmpl, typeFilter });
  

  const renderSpecializationFilters = () => (
    <div className="specialization-filters">
      {showTitle && <h5 className="filter-title">Спеціалізація</h5>}
      <div className="filter-items-single">
        {_filters_tmpl.specialization.map((d, i) => (
          <div className="form-check" key={`special${i}`}>
            <input 
              className="form-check-input" 
              type="checkbox" 
              checked={filters.specialization[d.field] ? true : false} 
              onChange={() => setGroupsFilter(d.field, 'specialization')} 
              id={`special${i}`}
            />
            <label className="form-check-label" htmlFor={`special${i}`}>
              {d.label}
            </label>
          </div>
        ))}
      </div>
    </div>
  );

  const renderDiseaseFilters = () => (
    showDiseaseFilters && (
      <div className="disease-filters-section">
        {showTitle && <h5 className="filter-title">Вид захворювання</h5>}
        <div className={`filter-items-single disease-filters ${layout === 'double' ? 'disease-filters-double' : ''}`}>
          {/* Санаторні захворювання */}
          {showSanatoriumDiseases && (
            <div className="disease-category">
              {layout === 'double' && <h6 className="disease-subtitle">Санаторні захворювання</h6>}
              {_filters_tmpl.disease_type.slice(0, 6).map((d, i) => (
                <div className="form-check" key={`sanat${i}`}>
                  <input
                    className="form-check-input"
                    type="checkbox"
                    checked={filters.disease_type[d.field] ? true : false}
                    onChange={() => setGroupsFilter(d.field, 'disease_type')}
                    id={`disease${i}`}
                  />
                  <label className="form-check-label" htmlFor={`disease${i}`}>
                    {d.label}
                  </label>
                </div>
              ))}
            </div>
          )}
          
          {/* Спеціальні захворювання */}
          {showSpecialDiseases && (
            <div className="disease-category">
              {layout === 'double' && <h6 className="disease-subtitle">Спеціальні захворювання</h6>}
              {_filters_tmpl.disease_type.slice(6).map((d, i) => (
                <div className="form-check" key={`spec${i}`}>
                  <input
                    className="form-check-input"
                    type="checkbox"
                    checked={filters.disease_type[d.field]}
                    onChange={() => setGroupsFilter(d.field, 'disease_type')}
                    id={`disease${i + 6}`}
                  />
                  <label className="form-check-label" htmlFor={`disease${i + 6}`}>
                    {d.label}
                  </label>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    )
  );

  return (
    <div className={`disease-specialization-filter ${className} ${layout === 'double' ? 'layout-double' : 'layout-single'}`}>
      {layout === 'single' ? (
        <>
          {renderSpecializationFilters()}
          {renderDiseaseFilters()}
        </>
      ) : (
        <div className="filter-columns-double">
          <div className="filter-column">
            {renderSpecializationFilters()}
          </div>
          <div className="filter-column">
            {renderDiseaseFilters()}
          </div>
        </div>
      )}
    </div>
  );
};

export default DiseaseSpecializationFilter;